// extracted by mini-css-extract-plugin
export default {"featuredList":"Features_featuredList__xW84b"};